angular
	.module('formRecoveryPassword.components', [])
	.component('formRecoveryPassword', {
		templateUrl: 'ng/components/formRecoveryPassword/formRecoveryPassword.html',
		bindings: {
			email: '=',
			appConfig: '='
		},
		controllerAs: 'formRecoveryPasswordCtrl',
		controller: function (HttpService, $sessionStorage, $rootScope, $scope, validationService, $userService, $configService) {
			this.confirmedPassword = {};

			/** Not to loose *this reference **/
			var self = this;

			self.dealerUser = {};

			$scope.fr = {};
			this.context = $rootScope.context;
			/** Validation Object **/
			this.validations = {};
			this.propMap = propMap;
			this.validationService = validationService;

			$scope.pwChangeSuccess = 2;
			//$scope.isConv = false;
			this.status = $configService.getAppConfig().user.status;
			$scope.fr = $configService.getAppConfig();
			$scope.enableMenu = function () {
				$rootScope.isMenuDisabled = false;
			}
			$scope.editBool = {
				tel: false
			}

			$scope.clickCloseRecoveryPassword = $scope.$parent.clickCloseRecoveryPassword;
			this.recoveryNewPassword = function () {

				/** Valid form first, if it is invalid overlayAlert and return **/
				/** required check **/
				//in recupero
				if (!this.isRequiredOk()) {
					$rootScope.$broadcast('addAlert', { text: 'CHANGEPASS_003' });
					return;
				}
				/** validity check **/
				if (!this.isValidationOk()) {
					$rootScope.$broadcast('addAlert', { text: 'CHANGEPASS_004' });
					return;
				}

				/** **/
				if (this.appPasswordUser.password != this.appPasswordUser.confirmedPassword) {
					$rootScope.$broadcast('addAlert', { text: 'CHANGEPASS_008' });
					return;
				}

				/** Logic **/
				if (this.appPasswordUser.password == this.appPasswordUser.confirmedPassword && this.appPasswordUser.password != this.appPasswordUser.recovery) {
					this.appPasswordUser.email = this.email;

					if ($configService.getUserStatus() == propMap['USER_STATUS_RECOVERY']) {
						$userService.restorePassword(this.appPasswordUser)
							.then(function (response) {
								if (response.success) {
									$rootScope.$broadcast('addAlert', { text: 'CHANGEPASS_005' });

									$rootScope.isMenuDisabled = false;
									$scope.clickCloseRecoveryPassword();
								}
							});
					}
					if ($configService.getUserStatus() == propMap['USER_STATUS_ENABLED']) {
						HttpService.send('/user/auth/updatePassword', this.appPasswordUser).then(function (response) {
							if (response.success) {
								$rootScope.$broadcast('addAlert', { text: 'CHANGEPASS_005' });

								//$configService.getUser() = response.appUser;
								$sessionStorage.appConfig = $configService.getAppConfig();

								/** initialize fields **/
								self.appPasswordUser = {};
								self.appPasswordUser.recovery = null;
								self.appPasswordUser.password = null;
								self.appPasswordUser.confirmedPassword = null;

								/** valid the form **/
								setFormIsValid($scope);
								$rootScope.isMenuDisabled = false;
								$scope.clickCloseRecoveryPassword();
							}
						});
					}

					if ($configService.getUserStatus() == propMap['USER_STATUS_NEW_USER_R']) {

						HttpService.send('/user/insertAppPassword', self.appPasswordUser).then(function (response) {
							if (response.success) {
								$rootScope.$broadcast('addAlert', { text: 'CHANGEPASS_005' });

								//$configService.getUser() = response.appUser;
								$sessionStorage.appConfig = $configService.getAppConfig();
								$rootScope.isMenuDisabled = false;
								$scope.clickCloseRecoveryPassword();
							}
						});
					}

				} else {
					$rootScope.$broadcast('addAlert', { text: 'CHANGEPASS_008' });
					return;
				}

			}

			this.checkOldAndNewPassword = function () {
				if (this.appPasswordUser.password == this.appPasswordUser.recovery) {
					this.controlNew = true;
				}
				else
					this.controlNew = false;

			}

			this.checkNewAndConfirmedPassword = function () {
				if (this.appPasswordUser.password != this.appPasswordUser.confirmedPassword) {
					this.controlConfirm = true;
				}
				this.controlConfirm = false;
			}


			function setFormIsValid(scope) {
				scope.FormChangePassword.inputConfirmRecovery.$valid = true;
				scope.FormChangePassword.inputNewRecovery.$valid = true;
				scope.FormChangePassword.inputOldRecovery.$valid = true;

				scope.FormChangePassword.inputConfirmRecovery.$touched = false;
				scope.FormChangePassword.inputNewRecovery.$touched = false;
				scope.FormChangePassword.inputOldRecovery.$touched = false;
				console.log(scope);
			}

			this.initializeUser = function () {

			}

			this.$onInit = function () {
				if ($configService.userIsRegistering()) { // || $rootScope.isConv=='false'
					//console.log('!isConv');

					this.disableClose = true;
				} else {
					this.disableClose = false;
				}
				console.log('this: ', this);

				/**
				 * Initialize validation Rules
				 */
				this.validations = {
					errorMessages: {
						passwordRecovery: 'La Password deve contenere da 8 a 16 caratteri alfanumerici, con almeno una lettera maiuscola, una minuscola ed un numero',
						passwordOldRecovery: 'La Password deve contenere da 8 a 16 caratteri alfanumerici, con almeno una lettera maiuscola, una minuscola ed un numero',
						passwordNewRecovery: 'La Password deve contenere da 8 a 16 caratteri alfanumerici, con almeno una lettera maiuscola, una minuscola ed un numero',
					},
					regex: {
						password: validationService.passwordRegex
					}
				}

			}

			/**
			 * Validation Logic
			 */

			//changing password
			this.isValidationOkChanging = function () {
				if (!this.appPasswordUser
					|| !this.appPasswordUser.password
					|| !this.appPasswordUser.confirmedPassword
					|| !this.appPasswordUser.inputOldRecovery
					|| !this.validationService.isValidPassword(this.appPasswordUser.password)
					|| !this.validationService.isValidPassword(this.appPasswordUser.confirmedPassword)
					|| !this.validationService.isValidPassword(this.appPasswordUser.inputOldRecovery)) {
					return false;
				}
				return true;
			}

			this.isValidationOk = function () {
				if (this.status === propMap['USER_STATUS_NEW_USER_R']) {
					if (!this.appPasswordUser
						|| !this.appPasswordUser.password
						|| !this.appPasswordUser.confirmedPassword
						|| !this.validationService.isValidPassword(this.appPasswordUser.password)
						|| !this.validationService.isValidPassword(this.appPasswordUser.confirmedPassword)) {
						return false;
					}
					return true;
				} else {
					if (!this.appPasswordUser
						|| !this.appPasswordUser.password
						|| !this.appPasswordUser.confirmedPassword
						|| !this.appPasswordUser.recovery
						|| !this.validationService.isValidPassword(this.appPasswordUser.password)
						|| !this.validationService.isValidPassword(this.appPasswordUser.confirmedPassword)
						|| !this.validationService.isValidPassword(this.appPasswordUser.recovery)) {
						return false;
					}
					return true;
				}
			}
			//changing password
			this.isRequiredOkChanging = function () {
				if (!this.appPasswordUser
					|| !this.appPasswordUser.password
					|| !this.appPasswordUser.confirmedPassword
					|| !this.appPasswordUser.inputOldRecovery) {
					return false;
				}
				return true;
			}

			this.isRequiredOk = function () {
				if (this.status === propMap['USER_STATUS_NEW_USER_R']) {
					if (!this.appPasswordUser
						|| !this.appPasswordUser.password
						|| !this.appPasswordUser.confirmedPassword) {
						return false;
					}
					return true;
				} else {
					if (!this.appPasswordUser
						|| !this.appPasswordUser.password
						|| !this.appPasswordUser.confirmedPassword
						|| !this.appPasswordUser.recovery) {
						return false;
					}
					return true;
				}
			}

			$scope.startScrollBar = function () {
				if (!$('#collapseFour.mCustomScrollbar').length) {
					scrollBar(true);
				}
			}



			/* GUIDA AI SERVIZI */
			//$configService.getUser()
			this.generateDownloadLink = function (nameFile) {
				return $configService.getAppConfig().url + '/uni/download/service-infos/' + encodeURIComponent(nameFile) + '/?token=' + $configService.getAppConfig().token;
			}



			/* ANAGRAFICA E RECAPITI */

			this.saveInfo = function (data) {
				$scope.fr.user.tel = data;

				HttpService.send('/user/updateAppUser', $scope.fr.user).then(function (response) {
					if (response.success) {
						$scope.editBool.tel = false;
					}

				});


			}
			self.getDealerUser = function () {
				$userService.getDealerUser()
					.then(function (dealer) {
						if (dealer) {
							self.dealerUser = dealer;
						}
					})
			}

		}

	});
